// extracted by mini-css-extract-plugin
export var backdropBlur = "_jg-0";
export var contentCard = "_jg-5";
export var frame = "_jg-2";
export var image = "_jg-4";
export var imagePane = "_jg-3";
export var modal = "_jg-1";